import Service from './service'
import Privacy from './privacy'

export default function Terms() {
  return (
    <div className='container mb-16'>
      <SectionTitle title='StyleMap 使用者服務條款' />
      <ScrollBox>
        <Service />
      </ScrollBox>
      <SectionTitle title='StyleMap 隱私權政策' />
      <ScrollBox>
        <Privacy />
      </ScrollBox>
    </div>
  )
}

const SectionTitle = ({ title }) => (
  <div className='text-[1.5rem] text-center py-4 mt-4 text-gray-600 font-medium'>
    { title }
  </div>
)

const ScrollBox = ({ children }) => (
  <div className='h-[60vh] border p-3 text-sm text-gray-700 leading-6 overflow-scroll'>
    { children }
  </div>
)
